module.exports = __webpack_public_path__ + "static/img/AM2.aeea93d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/labels/AM2.jpg
// module id = G1kg
// module chunks = 1